import React from "react";
import { setLogin } from "../../actions/user";
import { tempAlWait } from "../../helpers";
import { connect } from "react-redux";

class Signin extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        form: {
            email: '',
            mdp: ''
        },
        emailFocus: false,
        mdpFocus: false
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.alert != prevState.alert) {
            this.props.changeAlert(this.state.alert);
        }
        if (this.props.redLogin != prevProps.redLogin) {
            this.setState({
                alert: this.props.redLogin.alert
            })
            setTimeout(() => {
                if (this.props.redLogin.alert.type == "succ") {
                    window.location.href = `https://${this.props.idtt.slug}.fr`;
                }
            }, 3000);
        }
    }

    handleLogin = (el) => {
        el.preventDefault();
        this.props.setLogin({
            email: this.state.form.email,
            mdp: this.state.form.mdp
        });
        this.setState({
            alert: tempAlWait()
        })
    }
    
    render() {
        return <div className={`signin ${this.props.otherClass != null && `signin--${this.props.otherClass}`}`}>
            <h2 className="signin__ttl">Connexion</h2>
            <form className="signin__form">
                <p className="signin__help">* champs obligatoires</p>
                {/** Email **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir votre adresse e-mail"
                    aria-label="Assurez-vous de saisir votre adresse e-mail"
                >
                    <label htmlFor="signin-email" className={`signin__lab ${(this.state.emailFocus || this.state.form.email != "") && "signin__lab--reduce" }`}>
                        E-mail *
                    </label>
                    <input
                        type="email"
                        className="signin__inp"
                        id="signin-email"
                        required
                        value={this.state.form.email}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    email: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({emailFocus: true})}
                        onBlur={() => this.setState({emailFocus: false})}
                    />
                </div>
                {/** Mot de passe **/}
                <div
                    title="Assurez-vous de saisir votre mot de passe"
                    aria-label="Assurez-vous de saisir votre mot de passe"
                    className="signin__inpgrp"
                >
                    <label htmlFor="signin-mdp" className={`signin__lab ${(this.state.mdpFocus || this.state.form.mdp != "") && "signin__lab--reduce" }`}>
                        Mot de passe *
                    </label>
                    <input
                        type="password"
                        className="signin__inp"
                        id="signin-mdp"
                        required
                        value={this.state.form.mdp}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    mdp: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({mdpFocus: true})}
                        onBlur={() => this.setState({mdpFocus: false})}
                    />
                </div>
                {/** Bouton validation **/}
                <button
                    title="Se connecter"
                    aria-label="Se connecter"
                    className="signin__btn"
                    type="button"
                    onClick={(el) => this.handleLogin(el)}
                >
                    Je me connecte
                </button>
            </form>
            {/** Footer **/}
            <footer className="signin__ftr">
                <button
                    title="J'ai oublié mon mot de passe"
                    aria-label="J'ai oublié mon mot de passe"
                    className="signin__link"
                    onClick={() => this.props.changeStep("forgot-one")}
                >
                    Mot de passe oublié ?
                </button>
                <button
                    title="Pas encore de compte"
                    aria-label="Pas encore de compte"
                    className="signin__link"
                    onClick={() => this.props.changeStep("signup")}
                >
                    Créer un compte
                </button>
            </footer>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redLogin: state.redLogin
    }
}

const mapDispatchToProps = {
    setLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(Signin);